import React from 'react';
import Icon from '../../../components/AppIcon';

const DisputeResolution = () => {
  const steps = [
    {
      step: 1,
      title: "Direct Communication",
      description: "Contact our customer service team first. Most issues are resolved quickly through direct conversation.",
      timeframe: "Response within 24 hours",
      icon: "MessageSquare"
    },
    {
      step: 2,
      title: "Formal Complaint",
      description: "If direct communication doesn't resolve the issue, submit a formal written complaint to our legal department.",
      timeframe: "Resolution within 7 business days",
      icon: "FileText"
    },
    {
      step: 3,
      title: "Mediation",
      description: "For complex disputes, we'll engage a neutral third-party mediator to help find a fair solution.",
      timeframe: "Mediation within 30 days",
      icon: "Users"
    },
    {
      step: 4,
      title: "Arbitration",
      description: "As a last resort, binding arbitration through the American Arbitration Association will resolve the dispute.",
      timeframe: "Final resolution within 90 days",
      icon: "Scale"
    }
  ];

  return (
    <div className="bg-white rounded-xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center">
          <Icon name="Shield" size={20} className="text-secondary" />
        </div>
        <div>
          <h2 className="font-jakarta font-bold text-xl text-text-primary">
            Dispute Resolution Process
          </h2>
          <p className="text-text-secondary font-inter text-sm">
            Fair and transparent resolution for any disagreements
          </p>
        </div>
      </div>
      <div className="space-y-6">
        {steps?.map((step, index) => (
          <div key={step?.step} className="relative">
            {index < steps?.length - 1 && (
              <div className="absolute left-6 top-12 w-0.5 h-16 bg-border"></div>
            )}
            
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={step?.icon} size={20} className="text-primary" />
              </div>
              
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="w-6 h-6 bg-primary text-white rounded-full flex items-center justify-center text-xs font-bold">
                    {step?.step}
                  </span>
                  <h3 className="font-jakarta font-semibold text-lg text-text-primary">
                    {step?.title}
                  </h3>
                </div>
                
                <p className="text-text-secondary font-inter mb-2">
                  {step?.description}
                </p>
                
                <div className="inline-flex items-center space-x-2 bg-surface px-3 py-1 rounded-full">
                  <Icon name="Clock" size={14} className="text-primary" />
                  <span className="text-xs font-inter text-text-primary font-medium">
                    {step?.timeframe}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 bg-success/5 rounded-lg border border-success/20">
        <div className="flex items-start space-x-3">
          <Icon name="CheckCircle" size={20} className="text-success flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-jakarta font-semibold text-text-primary mb-1">
              Our Commitment
            </h3>
            <p className="text-sm font-inter text-text-secondary">
              We're committed to resolving disputes fairly and quickly. Over 95% of issues 
              are resolved in step 1 or 2, reflecting our commitment to customer satisfaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisputeResolution;